export const scopeLabels = {
  "Scope 1": "Scope 1 – Direkte Emissionen",
  "Scope 2": "Scope 2 – Indirekte Energieemissionen",
  "Scope 3": "Scope 3 – Sonstige indirekte Emissionen",
  "Scope 1.1": "Stationäre Verbrennung",
  "Scope 1.2": "Mobile Verbrennung",
  "Scope 2.1": "Eingekaufter Strom",
  "Scope 2.2": "Eingekaufte Wärme/Dampf/Kälte",
  "Scope 3.1": "Eingekaufte Güter & Dienstleistungen",
  "Scope 3.1.1": "Eingekaufte Ersatzteile",
  "Scope 3.1.2": "Eingekaufte Lacke",
  "Scope 3.1.3": "Eingekaufte Verbrauchsmaterialien",
  "Scope 3.2": "Investitionsgüter",
  "Scope 3.3": "Upstream Brennstoff & Energie",
  "Scope 3.3.1": "Upstream Brennstoff & Energie (Strom)",
  "Scope 3.3.2": "Upstream Brennstoff & Energie (Öl)",
  "Scope 3.3.3": "Upstream Brennstoff & Energie (Gas)",
  "Scope 3.3.4": "Upstream Brennstoff & Energie (Fernwärme)",
  "Scope 3.3.5": "Upstream Brennstoff & Energie (Holz)",
  "Scope 3.3.6": "Upstream Brennstoff & Energie (Treibstoff)",
  "Scope 3.5": "Abfallentsorgung"
};

export function getScopeLabel(scope) {
  return scopeLabels[scope] || scope;
}
